import { SvgIconProps } from "@mui/joy";
import { climbStyleValues, climbSkillValues, holdTypeValues } from "griptonite-api-client";

import { iconsByType } from "../assets/icons/traits";

const traitsByType = {
  holds: holdTypeValues,
  skills: climbSkillValues,
  styles: climbStyleValues,
} as const;

type TraitsByType = typeof traitsByType;

export type TraitName = keyof TraitsByType;
export type TraitValue<T extends TraitName = TraitName> = TraitsByType[T][number];

export const getTraitChoices = <T extends TraitName>(trait: T) => {
  return traitsByType[trait];
};

export const getTraitIcon = (trait: TraitName, value: TraitValue) => {
  const mapping = iconsByType[trait] as unknown as Record<
    TraitValue,
    (props: SvgIconProps) => JSX.Element | undefined
  >;
  return mapping[value] || (() => null);
};

export const getTraitLabel = (_trait: TraitName, value: TraitValue) => {
  // Values are SNAKE_CASE, so "SHORT_REACH" becomes "Short reach".
  const words = value.replace(/_/g, " ");
  return words[0].toUpperCase() + words.slice(1).toLowerCase();
};
